module.exports = __webpack_public_path__ + "04_short_brown.714aadbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/04_short_brown.png
// module id = hY1O
// module chunks = 0